import * as actionTypes from './actionTypes';

import axios from '../../util/axios-portals';

export const loadSettlementsFail = (error) => {
    return {
        type: actionTypes.SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_FAIL, 
        error
    };
}

export const loadSettlementsSuccess = (settlements) => {
    return {
        type: actionTypes.SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_SUCCESS, 
        settlements
    };
}

export const loadSettlementsStart = () => {
    return {
        type: actionTypes.SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_START
    };
}

export const loadSettlementsFromServer = (start, end, token) => {
    return (dispatch) => {
        dispatch(loadSettlementsStart());

        axios.get(`/settlements?start=${start}&end=${end}`, {
            headers: {
                'Authorization': `Bearer ${token}`, 
                'Accept': 'application/json'
            }
        })
        .then(response => dispatch(loadSettlementsSuccess(response.data.settlements)))
        .catch(err => dispatch(loadSettlementsFail(err)));
    };
}

export const loadSettlementsFromCache = () => {
    return {
        type: actionTypes.SETTLEMENT_GET_SETTLEMENTS_FROM_CACHE, 
        settlements: []
    };
}

/***** SINGLE SETTLEMENT *****/

export const loadSettlementFromServerStart = () => {
    return {
        type: actionTypes.SETTLEMENT_GET_START
    };
}

export const loadSettlementFromServerSuccess = (settlement) => {
    return {
        type: actionTypes.SETTLEMENT_GET_SUCCESS, 
        settlement
    };
}

export const loadSettlementFromServerFail = (error) => {
    return {
        type: actionTypes.SETTLEMENT_GET_FAIL, 
        error
    };
}

export const loadSettlementFromServer = (check_id, token) => {
    return (dispatch) => {
        dispatch(loadSettlementFromServerStart());

        axios.get(`/settlements/view/${check_id}`, {
            headers: {
                'Authorization': `Bearer ${token}`, 
                'Accept': 'application/json'
            }
        })
        .then(response => {
            const { details, settlements } = response.data;
            dispatch(loadSettlementFromServerSuccess({ details, settlements }));
        })
        .catch(err => loadSettlementFromServerFail(err));
    };
}